import React, { useState } from 'react'
import BlockchainIcon from 'src/assets/components/BlockchainIcon'
import { CopyText } from 'src/components/shared/CopyText'
import 'src/components/shared/IBCPathDisplay.css'

type Props = {
  counterPartyChain: string
  path: string
  baseDenom: string
}

export const IBCPathDisplay: React.FC<Props> = ({ counterPartyChain, path, baseDenom }) => {
  const [showAll, setShowAll] = useState(false)
  const segments = path.split('/')
  const hops = []
  for (let i = 0; i < segments.length; i += 2) {
    hops.push(`${segments[i]}/${segments[i + 1]}`)
  }

  const displayedHops = showAll ? hops : hops.slice(0, 2)

  return (
    <div className={'ibc-path-display'}>
      <small><strong>Receive Path:</strong></small>
      <div style={{ marginLeft: '1em', marginTop: '0.5em' }}>
        {displayedHops.map((hop, idx) => {
          const displayBlockchain = (idx === 0 && 'carbon') || (idx === 1 && counterPartyChain) || ''
          return (
            <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.3em' }}>
              <small>
                <BlockchainIcon blockchain={displayBlockchain} className={'blockchain-icon'} /> {hop}
              </small>
              <CopyText copyText={hop} text={''} />
            </div>
          )
        })}
        {hops.length > 3 && (
          <div
            onClick={() => setShowAll(!showAll)}
            style={{ marginTop: '0.5em', fontSize: '0.8em', cursor: 'pointer' }}
          >
            {showAll ? 'Show Less' : `Show ${hops.length - 2} More`}
          </div>
        )}
      </div>
      <div style={{ marginTop: '0.5em' }}>
        <small><strong>Base Denom:</strong></small>
        <div style={{
          marginLeft: '1em',
          marginTop: '0.5em',
          display: 'flex',
          alignItems: 'center',
          gap: '0.3em',
          wordBreak: 'break-word'
        }}
        >
          <small>{baseDenom}</small> <CopyText copyText={baseDenom} text={''} />
        </div>
      </div>
    </div>
  )
}
